import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Per-customer comms-notes guidance (the steer injected into AR LLM prompts),
 * with a save action. Distinct from the activity-timeline notes.
 */
export function useArCustomerCommsNotes(customerId: string) {
  const queryClient = useQueryClient();

  const queryOptions =
    orpc.accountsReceivable.arCustomerCommsNotes.get.queryOptions({
      input: { customerId },
    });

  const query = useQuery(queryOptions);

  const saveMutation = useMutation(
    orpc.accountsReceivable.arCustomerCommsNotes.set.mutationOptions({
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: queryOptions.queryKey });
      },
    }),
  );

  const appendMutation = useMutation(
    orpc.accountsReceivable.arCustomerCommsNotes.append.mutationOptions({
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: queryOptions.queryKey });
      },
    }),
  );

  return {
    ...query,
    notes: query.data?.notes ?? null,
    updatedAt: query.data?.updatedAt ?? null,
    save: (notes: string) => saveMutation.mutateAsync({ customerId, notes }),
    isSaving: saveMutation.isPending,
    append: (note: string) => appendMutation.mutateAsync({ customerId, note }),
    isAppending: appendMutation.isPending,
  };
}
